import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Colors } from '../../../product/colors/Colors';
import Store from '../../../Store';
import usePropState from '../../common/hook/usePropState';
import HomepageButton from '../../components/Buttons/HomepageButton/HomepageButton';
import ChangePasswordHomeModal from '../../components/Modals/ChangePasswordHomeModal/ChangePasswordHomeModal';
import LoginModal from '../../components/Modals/LoginModal/LoginModal';
import PasswordRecoveryModal from '../../components/Modals/PasswordRecoveryModal/PasswordRecoveryModal';
import RegisterModal from '../../components/Modals/RegisterModal/RegisterModal';
import './HomePage.css';
import ProgressiveMainHero from '../../components/ProgressiveMainHero';

const CONFIG = {
  cz: {
    title: 'Sõnasiht – Mluv směleji, sebevědoměji',
    description:
      'Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz Sõnasiht ti pomůže k úspěchu. Připoj se k eLingu a využij jeho výhod!',
  },
  cs: {
    title: 'Sõnasiht – Mluv směleji, sebevědoměji',
    description:
      'Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz Sõnasiht ti pomůže k úspěchu. Připoj se k eLingu a využij jeho výhod!',
  },
  hu: {
    title: 'Sõnasiht – Beszélj merészebben, magabiztosabban',
    description:
      'Javítsd nyelvi készségeidet gyakorlati tanfolyamokkal. Az Sõnasiht nyelvi tanfolyam segít sikeressé válni. Csatlakozz az eLingóhoz és profitálj belőle!',
  },
  en: {
    title: 'Sõnasiht – Speak more boldly, confidently',
    description:
      'Boost your language skills with practical courses. The Sõnasiht language course will help you succeed. Join Sõnasiht and benefit!',
  },
  sk: {
    title: "Sõnasiht – Hovor' smelšie, sebavedomejšie",
    description:
      'Zlepšite svoje jazykové zručnosti s praktickými kurzami. Jazykový kurz Sõnasiht vám pomôže uspieť. Pripojte sa k eLingu a získajte výhody!',
  },
  lt: {
    title: 'Sõnasiht – Kalbėk drąsiau, pasitikėdamas savimi',
    description:
      'Patobulink savo kalbos įgūdžius praktiškuose kursuose. Sõnasiht kalbų kursas padės siekti sėkmės. Prisijunk prie Sõnasiht ir pasinaudok privalumais!',
  },
  hr: {
    title: 'Sõnasiht – Govori smjelije, samopouzdanije',
    description:
      'Unaprijedi svoje jezične vještine praktičnim tečajevima. Jezični tečaj Sõnasiht pomoći će ti uspjeti. Pridruži se eLingu i iskoristi prednosti!',
  },
  ro: {
    title: 'Sõnasiht – Vorbește mai îndrăzneț, mai încrezător',
    description:
      'Îmbunătățește-ți abilitățile lingvistice cu cursuri practice. Cursul de limbă Sõnasiht te va ajuta să reușești. Alătură-te Sõnasiht și beneficiază!',
  },
  lv: {
    title: 'Sõnasiht | Droši runājiet jebkurā valodā!',
    description:
      'Uzlabojiet savas valodas prasmes ar praktiskiem kursiem. Sõnasiht valodas kurss palīdzēs jums panākt panākumus. Pievienojieties Sõnasiht un izmantojiet tā priekšrocības!',
  },
  pl: {
    title: 'Sõnasiht - Mów odważniej, pewniej siebie',
    description:
      'Zwiększ swoje umiejętności językowe dzięki praktycznym kursom. Kurs językowy Sõnasiht pomoże Ci odnieść sukces. Dołącz do Sõnasiht i korzystaj!',
  },
  bg: {
    title: 'Sõnasiht - Говорете по-смело и уверено',
    description:
      'Усъвършенствайте езиковите си умения с практически курсове. Езиковият курс на Sõnasiht ще ви помогне да постигнете успех. Присъединете се към Sõnasiht и се възползвайте!',
  },
  et: {
    title: 'Sõnasiht võõrkeelekursused | Arvamused ja ülevaated platvormi kohta',
    description:
      'Tutvu kõigega Sõnasiht kohta: õppemeetod ja kursuste eelised. Tuhanded rahul olevad õppijad. Liitu Sõnasiht-iga ja kasuta eeliseid!',
  },
  ru: {
    title: 'Языковые курсы Sõnasiht | Отзывы и обзоры платформы',
    description:
      'Узнайте всё о Sõnasiht: методика обучения и преимущества курсов. Тысячи довольных студентов. Присоединяйтесь к Sõnasiht и используйте все преимущества!',
  },
};

function HomePage({
  setError,
  isInitPasswordRecoveryModalOpen,
  isInitChangePasswordModalOpen,
}) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    usePropState(isInitChangePasswordModalOpen);
  const [isPasswordRecoveryModalOpen, setIsPasswordRecoveryModalOpen] =
    usePropState(isInitPasswordRecoveryModalOpen);

  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName('description')[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return (
    <div className='home-page'>
      {isLoginModalOpen && (
        <LoginModal
          isModalOpen={isLoginModalOpen}
          setIsModalOpen={setIsLoginModalOpen}
          setError={setError}
        />
      )}
      {isRegisterModalOpen && (
        <RegisterModal
          isModalOpen={isRegisterModalOpen}
          setIsModalOpen={setIsRegisterModalOpen}
          setError={setError}
        />
      )}
      {isPasswordRecoveryModalOpen && (
        <PasswordRecoveryModal
          isModalOpen={isPasswordRecoveryModalOpen}
          setIsModalOpen={setIsPasswordRecoveryModalOpen}
          setError={setError}
        />
      )}
      {isChangePasswordModalOpen && (
        <ChangePasswordHomeModal
          isModalOpen={isChangePasswordModalOpen}
          setIsModalOpen={setIsChangePasswordModalOpen}
          setError={setError}
        />
      )}
      <h2 className='home-page__header'>
        <span className='home-page__header--bold'>
          {Store.getText('homePageSloganFirstLine', true)}
        </span>{' '}
        {Store.getText('homePageSloganSecondLine', true)}
      </h2>
      <div className='home-page__boxes'>
        <div className='home-page__box'>
          <h3 className='home-page__box-header'>
            {Store.getText('login', true)}
          </h3>
          <p className='home-page__box-text'>
            {Store.getText('loginBoxDescription', true)}
          </p>
          <HomepageButton
            className='home-page__box-button'
            style={{ background: Colors.mainGradient }}
            onClick={() => setIsLoginModalOpen(true)}
          >
            {Store.getText('loginButtonText', true)}
          </HomepageButton>
        </div>

        <div className='home-page__box home-page__box--transparent'>
          <h3 className='home-page__box-header'>
            {Store.getText('register', true)}
          </h3>
          <p className='home-page__box-text'>
            {Store.getText('registerBoxDescription', true)}
          </p>
          <HomepageButton
            className='home-page__box-button'
            style={{ backgroundColor: Colors.accent1 }}
            onClick={() => setIsRegisterModalOpen(true)}
          >
            {Store.getText('registerButtonText', true)}
          </HomepageButton>
        </div>
      </div>
      <ProgressiveMainHero />
    </div>
  );
}

export default HomePage;
